@if (toggleEmoteList) {
<app-chat-emote-list (emoteSelected)="onEmoteSelected($event)"></app-chat-emote-list>
}
<div class="input-group">
  <input type="text" name="chat-input" placeholder="Start typing..." [(ngModel)]="message" (keypress)="sendMessage($event)" #chatInput />
  <div class="right">
    <button class="emote-button" (click)="toggleEmoteList = !toggleEmoteList" [class.active]="toggleEmoteList">
      <app-icon icon="emoji" />
    </button>
    <button class="send-button" (click)="sendMessage(null)">
      <app-icon icon="send" />
    </button>
  </div>
</div>
